import { toast } from "@skylead/component-library"

import ACTIONS from "../../constants/ACTIONS"
import integrationService from "../../services/integration.service"

function getActionSuccess(actionType, payload) {
  return { type: actionType, payload }
}

function getSupportedIntegrations() {
  return async (dispatch, getState) => {
    try {
      const userId = getState().user.profile.id
      const { teamId } = getState().teamManagement.selectedTeam

      const result = await integrationService.getSupportedIntegrations(userId, teamId)
      const supportedIntegrations = result.data.result.items

      dispatch(getActionSuccess(ACTIONS.GET_SUPPORTED_INTEGRATIONS, supportedIntegrations))
    } catch (error) {}
  }
}

function getTeamIntegrations() {
  return async (dispatch, getState) => {
    try {
      const userId = getState().user.profile.id
      const { teamId } = getState().teamManagement.selectedTeam
      const result = await integrationService.getTeamIntegrations(userId, teamId)
      const teamIntegrations = result.data.result.items
      dispatch(getActionSuccess(ACTIONS.GET_TEAM_INTEGRATIONS, teamIntegrations))
    } catch (error) {}
  }
}

function createDeal(tt, dealData) {
  return async (dispatch, getState) => {
    try {
      const userId = getState().user.profile.id?.toString()
      const { teamId } = getState().teamManagement.selectedTeam

      // Ensure all IDs are strings in the payload
      const payload = {
        teamId: teamId?.toString(),
        ...dealData,
      }

      const result = await integrationService.createDeal(userId, teamId?.toString(), payload)

      const deal = result.data.result

      dispatch(getActionSuccess(ACTIONS.CREATE_DEAL, deal))
      toast.success(tt("create-deal-successfully"))
      return deal
    } catch (error) {
      toast.error(error?.response?.data?.message || tt("create-deal-failed"))
      return false
    }
  }
}

function testTeamIntegration(integrationType) {
  return async (dispatch, getState) => {
    try {
      const userId = getState().user.profile.id
      const { teamId } = getState().teamManagement.selectedTeam

      const result = await integrationService.testTeamIntegration(userId, teamId, integrationType)
      const test = result.data.result.items

      dispatch(getActionSuccess(ACTIONS.TEST_TEAM_INTEGRATION, test))
    } catch (error) {}
  }
}

function verifyIntegration(config, integrationType) {
  return async (dispatch, getState) => {
    try {
      const userId = getState().user.profile.id
      const { teamId } = getState().teamManagement.selectedTeam

      const result = await integrationService.verifyIntegration(
        userId,
        teamId,
        config,
        integrationType,
      )

      const verificationResult = {
        isValid: result.data.result.isValid,
        error: result.data.result.error,
      }

      dispatch(getActionSuccess(ACTIONS.VERIFY_INTEGRATION, verificationResult))
      return verificationResult
    } catch (error) {
      const errorResult = {
        isValid: false,
        error: error?.response?.data?.message || "Verification failed",
      }
      dispatch(getActionSuccess(ACTIONS.VERIFY_INTEGRATION, errorResult))
      return errorResult
    }
  }
}

function updateTeamIntegration(tt, config, integrationType) {
  return async (dispatch, getState) => {
    try {
      const userId = getState().user.profile.id
      const { teamId } = getState().teamManagement.selectedTeam

      const result = await integrationService.updateTeamIntegration(
        userId,
        teamId,
        config,
        integrationType,
      )

      // Get fresh team integrations data after update
      await dispatch(getTeamIntegrations())

      toast.success(tt("update-team-integration-successfully"))
      return result
    } catch (error) {
      toast.error(error?.response?.data?.message || tt("update-team-integration-failed"))
      return false
    }
  }
}

function createTeamIntegration(tt, config, integrationType) {
  return async (dispatch, getState) => {
    try {
      const userId = getState().user.profile.id
      const { teamId } = getState().teamManagement.selectedTeam

      const result = await integrationService.createTeamIntegration(
        userId,
        teamId,
        config,
        integrationType,
      )

      // Get fresh team integrations data after create
      await dispatch(getTeamIntegrations())

      toast.success(tt("create-team-integration-successfully"))
      return result
    } catch (error) {
      toast.error(error?.response?.data?.message || tt("create-team-integration-failed"))
      return false
    }
  }
}

export {
  getSupportedIntegrations,
  getTeamIntegrations,
  createDeal,
  testTeamIntegration,
  verifyIntegration,
  updateTeamIntegration,
  createTeamIntegration,
}
